import React from 'react';
import UnitsPage from './UnitsPage';

const GruasPage = () => {
  return <UnitsPage tipoUnidad="Grua" title="Gruas" />;
};

export default GruasPage;
